// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__8oMg-","buttons":"Pagination_buttons__2o1Jm","buttonPage":"Pagination_buttonPage__FEJnN","buttonPageActive":"Pagination_buttonPageActive__NdVeU"};